<template>
  <v-text-field
    v-model="modelValue"
    outlined
    dense
    hide-details="auto"
    :disabled="disabled"
    :label="label"
    :placeholder="placeholder"
    :rules="computedRules"
    :hint="hint"
    :persistent-hint="!!hint"
    type="tel"
    v-mask="this.isTypeMonth ? '##/####' : '##/##/####'"
  >
    <template #append>
      <v-menu :close-on-content-click="false">
        <template #activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" :disabled="disabled">
            <v-icon>mdi-calendar-blank-outline</v-icon>
          </v-btn>
        </template>
        <v-date-picker no-title :max="getMaxDate()" :min="min" @change="changeDate" :type="type" />
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>
import { PropOptions, ComputedOptions } from 'vue'
import { mask } from 'vue-the-mask'
import { Computed, Method } from '@/_typedefs'
import { ValidationFunction } from '@/plugins/validation'

export default {
  name: 'DateInputComponent',
  props: {
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: 'dd/mm/yyyy',
    },
    /** @type {PropOptions<Array<(v: any) => boolean | string>>} */
    rules: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: null,
    },
    max: {
      type: String,
      default: null,
    },
    min: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'date',
    },
  },
  directives: {
    mask: {
      bind(el, binding, vnode, oldVnode) {
        if (binding.value) {
          mask(el, binding, vnode, oldVnode)
        }
      },
    },
  },
  computed: {
    /** @type {ComputedOptions<string | number>} */
    modelValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    /** @type {Computed<ValidationFunction[]>} */
    computedRules() {
      if (this.isTypeMonth) {
        const monthRules = [this.$validation.validMonth(), ...this.rules];
        if (this.max === 'TODAY') {
          return [this.$validation.monthTodayOrBefore(), ...monthRules];
        }
        return monthRules
      }
      return [this.$validation.validDate(), ...this.rules]
    },
    isTypeMonth() {
      return this.type === 'month'
    },
  },
  methods: {
    /** @type {Method<[date: string]>} */
    changeDate(date) {
      if (this.isTypeMonth) {
        this.modelValue = this.$moment(date).format('MM/YYYY')
      } else {
        this.modelValue = this.$moment(date).format('DD/MM/YYYY')
      }
    },
    getMaxDate() {
      if (this.max === 'TODAY') {
        return this.$moment().toISOString()
      }
      return null
    },
  },
}
</script>

<style scoped>
:deep(.v-input__slot) {
  min-height: 48px !important;
}
:deep(.v-text-field__details) {
  margin: 0 !important;
}
:deep(.v-btn--icon) {
  height: 32px;
  width: 32px;
}
</style>
